const inboxScreenFilters = ({ excludeUser }) => [
  //
  { type: 'showReadMessages', label: 'Show Read Messages', options: [{ label: 'Show Read Messages', value: true }], pinned: true },
  { type: 'userId', pinned: true, show: !excludeUser },
  { type: 'locationId', pinned: true },
  { type: 'search' },
];

export default inboxScreenFilters;
